import { useMemo } from 'react'
import type { Alarm } from 'src/Types/Alarm'

import { getAlarmTypeByAlarm } from 'src/Utils/alarms'

export const useAlarmTypeByAlarm = (alarm?: Alarm) => {
  return useMemo(() => (alarm ? getAlarmTypeByAlarm(alarm) : undefined), [alarm])
}
